(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gizet-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gizet-feedback')) {
    customElements.define('gizet-feedback', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog')
        this.form = this.querySelector('form')
        this.details = this.querySelector('[data-feedback-details]')
        this.status = this.querySelector('[data-feedback-status]')
        this.fileStatus = this.querySelector('[data-feedback-file]')
        this.categoryInput = this.querySelector('[name="category"]')
        this.userTypeInput = this.querySelector('[name="userType"]')
        this.sourcePageInput = this.querySelector('[name="sourcePage"]')
        this.submitButton = this.querySelector('[type="submit"]')
        this.photoInput = this.querySelector('[name="photo"]')
        this.voiceInput = this.querySelector('[name="voice"]')

        this.querySelector('.gizet-feedback__launcher').addEventListener('click', () => this.open())
        this.querySelector('[data-feedback-close]').addEventListener('click', () => this.dialog.close())
        this.querySelectorAll('[data-category]').forEach((button) => {
          button.addEventListener('click', () => this.selectCategory(button))
        })
        this.photoInput.addEventListener('change', () => this.selectFile(this.photoInput, this.voiceInput))
        this.voiceInput.addEventListener('change', () => this.selectFile(this.voiceInput, this.photoInput))
        this.form.addEventListener('submit', (event) => this.submit(event))
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close()
        })
      }

      open() {
        this.sourcePageInput.value = window.location.href
        this.status.textContent = ''
        this.status.removeAttribute('data-state')
        this.dialog.showModal()
      }

      selectCategory(button) {
        this.querySelectorAll('[data-category]').forEach((choice) => {
          choice.setAttribute('aria-pressed', choice === button ? 'true' : 'false')
        })
        this.categoryInput.value = button.dataset.category
        this.userTypeInput.value = button.dataset.userType
        const reveal = () => { this.details.hidden = false }
        if (document.startViewTransition) document.startViewTransition(reveal)
        else reveal()
        this.status.textContent = ''
        this.status.removeAttribute('data-state')
      }

      selectFile(activeInput, otherInput) {
        if (activeInput.files.length) otherInput.value = ''
        const file = activeInput.files[0]
        this.fileStatus.textContent = file ? file.name : ''
      }

      async submit(event) {
        event.preventDefault()
        if (!this.categoryInput.value) {
          this.status.textContent = this.dataset.choose
          this.status.dataset.state = 'error'
          return
        }

        this.submitButton.disabled = true
        this.status.textContent = ''
        this.status.removeAttribute('data-state')

        try {
          const response = await fetch(this.dataset.endpoint, {
            method: 'POST',
            body: new FormData(this.form),
          })
          const result = await response.json().catch(() => ({}))
          if (!response.ok || !result.success) throw new Error(result.error || this.dataset.error)

          this.status.textContent = this.dataset.success
          this.status.dataset.state = 'success'
          this.form.reset()
          this.details.hidden = true
          this.fileStatus.textContent = ''
          this.querySelectorAll('[data-category]').forEach((choice) => choice.setAttribute('aria-pressed', 'false'))
          window.setTimeout(() => this.dialog.close(), 1400)
        } catch (error) {
          this.status.textContent = error instanceof Error && error.message ? error.message : this.dataset.error
          this.status.dataset.state = 'error'
        } finally {
          this.submitButton.disabled = false
        }
      }
    })
  }
  } catch(e) { console.error(e); }
})();

})();
